import { AfterViewInit, Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { UserService } from '@app/services/user/user.service';

export const USER_ID = 'email'; // unique id refer to email

@Component({
  selector: 'app-mentions-filter-btn',
  templateUrl: './assign-mentions-filter.component.html',
  styleUrls: ['./assign-mentions-filter.component.scss'],
  standalone: false,
})
export class MentionsFiltersComponent implements AfterViewInit, OnDestroy {
  usersList = [];
  usersListOptions = [];
  isOpenMenu = false;
  selectedMentions = [];
  disabled = false;
  destroy$ = new Subject();
  onMentionSelectionChangedSubject = new Subject();
  @Output() onMentionFilterChanged = new EventEmitter<string[]>();

  constructor(private userService: UserService) {}

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  ngAfterViewInit() {
    this.userService.users$.pipe(takeUntil(this.destroy$)).subscribe((users) => {
      if (!users?.length) {
        return;
      }

      this.usersList = users.map((user) => {
        return {
          label: user.name,
          value: user[USER_ID],
          active: this.selectedMentions?.includes(user[USER_ID]) ? true : false,
          img: {
            path: user.profilePictureUrl,
            class: 'avatar',
          },
        };
      });
    });

    this.onMentionSelectionChangedSubject
      .pipe(takeUntil(this.destroy$), debounceTime(500))
      .subscribe((selected) => this.onMentionFilterChanged.emit(selected as any));
  }

  onUserMentionSelected(value) {
    this.selectedMentions = value.slice();
    this.onMentionSelectionChangedSubject.next(this.selectedMentions);
  }
}
